// extracted by mini-css-extract-plugin
export default {"dragger":"UploadButton_dragger__3jdE6"};